import { render, staticRenderFns } from "./SmartCollegeCard.vue?vue&type=template&id=6b96a67f&scoped=true&"
import script from "./SmartCollegeCard.vue?vue&type=script&lang=ts&"
export * from "./SmartCollegeCard.vue?vue&type=script&lang=ts&"
import style0 from "./SmartCollegeCard.vue?vue&type=style&index=0&id=6b96a67f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96a67f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VImg,VProgressLinear})
